// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__IiDPj","letter":"Avatar_letter__087pQ"};